import { client } from '@utils/graphql/setup';
import {
  QueryCreator,
  CriteriaCreator,
  MutationCreator,
  SingleRecordMutationCreator,
} from './base';
import { createAcceptedProperties } from '../helpers';
import * as is from 'is';
import { getLogger } from '@utils/general';
import { deleteApiKey, getApiKeys } from './apiKeys';
const logger = getLogger('src.utils.graphQL.creators.contacts');

const acceptedReturnProperties = createAcceptedProperties(
  'id',
  'firstName',
  'lastName',
  'title',
  'companyName',
  'primaryPhone',
  'emailAddress'
);

const acceptedCriteriaProperties = {
  id: { type: 'string' },
  firstName: { type: 'string' },
  lastName: { type: 'string' },
  title: { type: 'string' },
  companyName: { type: 'string' },
  primaryPhone: { type: 'string' },
  emailAddress: { type: 'string' },
};

class ContactCriteria extends CriteriaCreator {
  constructor(criteria = {}) {
    super(criteria);
  }
  get acceptedCriteria() {
    return acceptedCriteriaProperties;
  }
};

export class ContactsQuery extends QueryCreator {
  constructor(queryType = 'contacts') {
    super(queryType, ContactCriteria);
  }

  get acceptedReturnProperties() {
    return acceptedReturnProperties;
  }
}

export function getContacts(id, criteria = {}) {
  let query;
  if (id) {
    query = new ContactsQuery('contact');
    query.setId(id);
  } else {
    query = new ContactsQuery();
  }

  if (!is.empty(criteria)) {
    Object.keys(criteria).forEach((key) => {
      query.addCriteria(key, criteria[key]);
    });
  }

  query.addReturnProperties('first_name', 'last_name');

  return {
    query,
    execute() {
      return client.query(query.name, query.toString());
    },
  };
};

class ContactMutation extends MutationCreator {
  constructor(queryType = 'create_contact', criteria = {}) {
    super(queryType, ContactCriteria);
    this.setCriteria(criteria);
  }

  get acceptedReturnProperties() {
    return acceptedReturnProperties;
  }
}

export function saveContact(mutationType, input) {
  let mutation;
  mutation = new ContactMutation(mutationType, input);
  mutation.addReturnProperties('id', 'first_name', 'last_name');
  return {
    mutation,
    execute() {
      return client.mutate(mutation.name, mutation.toString());
    },
  };
}

export class SingleContactMutation extends SingleRecordMutationCreator {
  constructor(queryType = 'update_contact', criteria = {}) {
    super(queryType, ContactCriteria);
    this.setCriteria(criteria);
  }
  get acceptedReturnProperties() {
    return acceptedReturnProperties;
  }
}


export function updateContact(mutationType, id, input) {
  let mutation;
  mutation = new SingleContactMutation(mutationType, input);
  mutation.addReturnProperties('id', 'first_name', 'last_name');
  mutation.setId(id);

  return {
    mutation,
    execute() {
      return client.mutate(mutation.name, mutation.toString());
    },
  };
}

export const deleteContact = async (contact) => {
  const { execute: executeContactRemoval } = updateContact('remove_contact', contact.id);

  const { execute: executeGetApiKeys, query: apiKeyQuery} = getApiKeys(null, { contactId: contact.id });
  apiKeyQuery.addReturnProperties('id', 'user_key');

  try {
    const { error: getApiKeysError, data: apiKeysAssocWithContact } = await executeGetApiKeys();

    if (getApiKeysError) {
      throw new Error(getApiKeysError);
    }
    if (apiKeysAssocWithContact) {
      for (const apiKey of apiKeysAssocWithContact) {
        await deleteApiKey(apiKey);
      }
    }
    
    await executeContactRemoval();
  }
  catch (error) {
    logger.error(error, `Failed to delete contact ${contact.id}.`);
    throw new Error(error);
  }
};
